<div class="mini-drop-select">
    <div class="button-container" [ngClass]="hasError? 'error-container' : ''">
        <!-- Button for creating dropdown -->
        <button
            mat-button
            class="drop-button"
            (click)="toggleOptions()"
            (blur)="blurToggleOptions()"
            [disableRipple]="true"
            [ngClass]="hasError? 'error-button' : ''"
        >
            {{ label }}
            <!-- Downward Purple Arrow -->
            <div class="select-arrow" [ngClass]="{ 'error-arrow' : hasError, 'face-up' : showOptions }"></div>
        </button>
    </div>
    <!-- Drop Down Error Message -->
    <span class="error-message bottom-align" *ngIf="hasError">{{ customErrorMessage }}</span>
    <!-- Drop Down Options -->
    <ul class="drop-options" *ngIf="showOptions && options && options.length">
        <li 
            class="option"
            *ngFor="let option of options; let i = index"
            [class.active-option]="i == activeOptionIndex"
            (mousedown)="selectDropOption(option)"
        >
            {{ option.Key }}
        </li>
    </ul>
</div>